<div class="header-dots">

<!--  <div class="btn-group" ngbDropdown autoClose="outside" placement="bottom">-->
<!--    <button type="button" class="btn btn-link p-0 mr-2" ngbDropdownToggle>-->
<!--      <span>-->
<!--        <div class="icon-wrapper icon-wrapper-alt rounded-circle">-->
<!--          <div class="icon-wrapper-bg bg-danger"></div>-->
<!--          <i class="lnr-bullhorn text-danger"></i>-->
<!--          <div class="badge badge-dot badge-dot-sm badge-danger">Notificaciones</div>-->
<!--        </div>-->
<!--      </span>-->
<!--    </button>-->
<!--    <div class="dropdown-menu-xl" ngbDropdownMenu>-->
<!--&lt;!&ndash;      <ngx-loading [show]="loading"&ndash;&gt;-->
<!--&lt;!&ndash;                   [config]="{animationType: ngxLoadingAnimationTypes?.pulse, backdropBorderRadius: '3px'}"&ndash;&gt;-->
<!--&lt;!&ndash;                   [template]="loadingTemplate"></ngx-loading>&ndash;&gt;-->
<!--      <div class="dropdown-menu-header mb-0">-->
<!--        <div class="dropdown-menu-header-inner bg-deep-blue">-->
<!--          <div class="menu-header-image opacity-1 dd-header-bg-2"></div>-->
<!--          <div class="menu-header-content text-dark">-->
<!--            <h5 class="menu-header-title">Notificaciones</h5>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="card-tabbed-header">-->
<!--        <ngb-tabset class="tabs-animated tabs-animated-shadow" justify="justified">-->

<!--          <ngb-tab>-->
<!--            <ng-template ngbTabTitle><span>Eventos</span></ng-template>-->
<!--            <ng-template ngbTabContent>-->
<!--              <div class="scroll-gradient">-->
<!--                <div class="scroll-area-sm shadow-overflow">-->
<!--                  <perfect-scrollbar [autoPropagation]="true">-->
<!--                    <div-->
<!--                      class="vertical-without-time vertical-timeline vertical-timeline&#45;&#45;animate vertical-timeline&#45;&#45;one-column">-->
<!--                      <div class="vertical-timeline-item vertical-timeline-element" *ngFor="let notification of notificationList">-->
<!--                        <div><span class="vertical-timeline-element-icon bounce-in"><i-->
<!--                              class="badge badge-dot badge-dot-xl badge-success"></i></span>-->
<!--                          <div class="vertical-timeline-element-content bounce-vin">-->
<!--                            <h4 class="timeline-title">{{notification.title}}</h4>-->
<!--                            <p>{{notification.message}}</p>-->
<!--                            <p>{{notification.createdAt | date : 'dd-MM-yyyy HH:mm' : 'ISO'}}</p>-->
<!--                            <span-->
<!--                              class="vertical-timeline-element-date"></span>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->

<!--                    </div>-->
<!--                  </perfect-scrollbar>-->
<!--                </div>-->
<!--              </div>-->
<!--            </ng-template>-->
<!--          </ngb-tab>-->
<!--          <ngb-tab>-->
<!--            <ng-template ngbTabTitle><span>Estado</span></ng-template>-->
<!--            <ng-template ngbTabContent>-->
<!--              <div class="no-results">-->
<!--                <div *ngIf="user.valitedUser" class="swal2-icon swal2-success swal2-animate-success-icon">-->
<!--                  <div class="swal2-success-circular-line-left" style="background-color: rgb(255, 255, 255);"></div>-->
<!--                  <span class="swal2-success-line-tip"></span>-->
<!--                  <span class="swal2-success-line-long"></span>-->
<!--                  <div class="swal2-success-ring"></div>-->
<!--                  <div class="swal2-success-fix" style="background-color: rgb(255, 255, 255);"></div>-->
<!--                  <div class="swal2-success-circular-line-right" style="background-color: rgb(255, 255, 255);"></div>-->
<!--                </div>-->
<!--                <div *ngIf="user.valitedUser" class="results-subtitle">Activado!</div>-->
<!--                <div *ngIf="user.valitedUser" class="results-title">Tu cuenta está validada!</div>-->

<!--                <div *ngIf="!user.valitedUser" class="results-subtitle">Desactivado!</div>-->
<!--                <div *ngIf="!user.valitedUser" class="results-title">Tu cuenta no está validada!</div>-->
<!--              </div>-->
<!--            </ng-template>-->
<!--          </ngb-tab>-->
<!--        </ngb-tabset>-->
<!--      </div>-->
<!--      <div class="nav-justified">-->
<!--        <ul class="nav flex-column">-->
<!--          <li class="nav-item-divider nav-item mt-0"></li>-->
<!--          <li class="nav-item-btn text-center nav-item">-->
<!--            <a [routerLink]="['/my-notifications']" >-->
<!--              <button class="btn-shadow btn-wide btn-pill btn btn-focus btn-sm">Ver más</button>-->
<!--            </a>-->

<!--          </li>-->
<!--        </ul>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->

</div>
